import type { FaireProductEntity } from "../../entity_types/product";

export const p_bvou1u08qk: FaireProductEntity = {
  token: "p_bvou1u08qk",
  type: "product",
  name: "Marble Pig 2''",
  brandToken: "b_4e6hayu5vx",
  brandName: "SS handcrafted Art",
  imageUrl:
    "https://cdn.faire.com/fastly/0f50eeeb65d8ce22ccd03486ef39e90693eee667ea2dadb1920c951afc675b34.jpeg",
  galleryImageUrls: [],
  priceDollars: 4.3,
  description:
    "Color variations are expected\n\nSizes are approximate\n\nHandcrafted out of natural marble, in Ecuador\n\nWith every purchase, a portion goes to The Turtleman Foundation to help save one sea turtle at a time",
  tags: [],
  msrpDollars: 8.45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:39.076Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
